import { mediaData } from '@/mocks/home';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-play-circle-line"></i>
              深度视频
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              独家内容
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              资深娱记深度解析，还原娱乐圈真相
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
            {mediaData.map((item) => (
              <div
                key={item.id}
                className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-[16/10]">
                  <img
                    src={item.image}
                    alt={`51吃瓜网独家内容 - ${item.title}`}
                    title={`51吃瓜网 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="600"
                    height="340"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-background-50 text-[10px] font-medium">
                    {item.duration}
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 text-[10px] text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{item.views}次播放</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}